import { render, staticRenderFns } from "./AddNewCard.vue?vue&type=template&id=77c4d942&scoped=true"
import script from "./AddNewCard.vue?vue&type=script&lang=js"
export * from "./AddNewCard.vue?vue&type=script&lang=js"
import style0 from "./AddNewCard.vue?vue&type=style&index=0&id=77c4d942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c4d942",
  null
  
)

export default component.exports